<template>
  <div class="c-player-layout">
    <transition :key="$route.path" name="fade">
      <!-- don't use :key -->
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PlayerLayout',

  components: {},

  data: function () {
    return {}
  },

  methods: {}
}
</script>

<style lang="css" scoped>
.c-player-layout {
  min-height: 100vh;
  min-height: 100dvh;
}
</style>
